import React from 'react'
import spotify from '../icons/spotify.png'
import msteam from '../icons/msteam.png'
import messenger from '../icons/messenger.png'

const HiddenIconTray = () => {
  return (
    <div className='iconTray grid grid-cols-2 bg-white rounded-md overflow-hidden'>
        <div className='h-auto w-9 p-2 hover:bg-gray-200'><img src={spotify} alt="icon" /></div>
        <div className='h-auto w-9 p-2 hover:bg-gray-200'><img src={msteam} alt="icon" /></div>
        <div className='h-auto w-9 p-2 hover:bg-gray-200'><img src={messenger} alt="icon" /></div>
    </div>
  )
}

export default HiddenIconTray
